import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import {
  DsAutocompleteModule,
  DsBreadcrumbModule, DsCalendarModule, DsCheckboxModule, DsConfirmDialogModule,
  DsInputModule,
  DsKrsModule,
  DsLayoutModule,
  DsLoaderModule,
  DsMenuModule, DsModalModule, DsPanelModule,
  DsPortalModule, DsTableModule,
  DsTabViewModule,
  TranslocoRootModule,
} from 'design-system';
import { ComponentsModule } from './components/components.module';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { HttpErrorInterceptor } from './services/http-error/http-error.interceptor';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ReactiveFormsModule } from '@angular/forms';
import { ModulTozsamosciService } from './auth-lib/src/lib/modul-tosamosci/services/modul-tozsamosci-service/modul-tozsamosci.service';
import { initializeModulTozsamosci } from './auth-lib/src/lib/modul-tosamosci/utils/initialize-modul-tozsamosci';
import { ModulTozsamosciInterceptor } from './auth-lib/src/lib/modul-tosamosci/interceptors/modul-tozsamosci/modul-tozsamosci.interceptor';
import { PrsAuthFacadeService } from './auth-lib/src/lib/modul-tosamosci/services/prs-auth-facade-service/prs-auth-facade.service';
import { ModulTosamosciModule } from './auth-lib/src/lib/modul-tosamosci/modul-tosamosci.module';
import { OAuthModule } from 'angular-oauth2-oidc';
import { environment } from '../environments/environment';
import { MonitorowanePodmiotyWKrsComponent } from './pages/monitorowane-podmioty-w-krs/monitorowane-podmioty-w-krs.component';
import { SubskrypcjeComponent } from './pages/subskrypcje/subskrypcje.component';
import { PowiadomieniaComponent } from './pages/powiadomienia/powiadomienia.component';
import { JwtInterceptor } from './utils/jwt.interceptor';
import { PowiadomieniaTabelaComponent } from './pages/powiadomienia/powiadomienia-tabela/powiadomienia-tabela.component';
import { PowiadomieniaFiltryComponent } from './pages/powiadomienia/powiadomienia-filtry/powiadomienia-filtry.component';
import { ZdarzeniaComponent } from './pages/zdarzenia/zdarzenia.component';
import { ZdarzeniaFiltryComponent } from './pages/zdarzenia/zdarzenia-filtry/zdarzenia-filtry.component';
import { ZdarzeniaTabelaComponent } from './pages/zdarzenia/zdarzenia-tabela/zdarzenia-tabela.component';
import { CommunicateContainerModule } from './components/communicate-container/communicate-container.module';

@NgModule({
  declarations: [
    AppComponent,
    MonitorowanePodmiotyWKrsComponent,
    SubskrypcjeComponent,
    PowiadomieniaComponent,
    PowiadomieniaTabelaComponent,
    PowiadomieniaFiltryComponent,
    ZdarzeniaComponent,
    ZdarzeniaFiltryComponent,
    ZdarzeniaTabelaComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    ComponentsModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    TranslocoRootModule.forRoot(),
    DsPortalModule,
    DsLayoutModule,
    DsMenuModule.forRoot(),
    DsBreadcrumbModule,
    DsInputModule,
    DsTabViewModule,
    DsKrsModule,
    DsLoaderModule,
    OAuthModule.forRoot({
      resourceServer: {
        allowedUrls: environment.mt.allowedUrls,
        sendAccessToken: true,
      },
    }),
    DsPanelModule,
    DsTableModule,
    DsCalendarModule,
    DsAutocompleteModule,
    DsCheckboxModule,
    DsConfirmDialogModule,
    DsModalModule,
    ModulTosamosciModule,
    CommunicateContainerModule
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: initializeModulTozsamosci,
      multi: true,
      deps: [ModulTozsamosciService, PrsAuthFacadeService],
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ModulTozsamosciInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorInterceptor,
      multi: true,
    },
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
